import { TButtonData, TCommonData, TCommonWidgetValue, TInputData } from './widget/data';
import { TCalculatorData } from './widget/dataCalculator';
import { ActionSystemActionType } from './widget/enums';
import { TCommonBottomSheetOption, TCommonInputOption, TCommonOption } from './widget/options';
import { TWAction, TWidget } from './widget/widget';
import { Themes } from './theme';

export enum EStatus {
    Idle = 'idle',
    Delay = 'delay',
    WidgetLoading = 'widgetLoading',
    Loading = 'loading',
    Succeeded = 'succeeded',
    Forbidden = 'forbidden',
    ShowChallenge = 'showChallenge',
    Failed = 'failed',
}

const SCENARIO = 'scenario/';

export enum StoreActionTypeEnum {
    updateWidgetValueByInternalId = SCENARIO + 'updateWidgetValueByInternalId',
    updateWidgetValueByKey = SCENARIO + 'updateWidgetValueByKey',
    updateWidgetValue = SCENARIO + 'updateWidgetValue',
}

export interface ValidationErrors {
    errorMessage: string;
    isForbidden?: boolean;
    captchaBody?: string;
    widgetUid?: string;
    actionForRepeat?: TWAction;
    field_errors?: Record<string, string>;
}

export type TRequestUri = {
    path: string;
    data?: Record<string, string>;
};

export type TInitPayerOptions = {
    externalData?: Record<string, string>;
    requestUri?: TRequestUri;
};

export type TTriggerWidgetAction = {
    action: TWAction | undefined;
    widgetUid: string | undefined;
    isShowLoader?: boolean;
    playerId?: string;
    initPayerOptions?: TInitPayerOptions;
};

export interface IBaseState {
    status?: EStatus;
    errors?: ValidationErrors;
}
export type TConfiguration = {
    screenshotAvailable?: boolean;
    themes?: Themes;
    themesHash?: string;
};

export type IMutableWidgetsMap<TD, TO> = Record<string, TWidget<TD, TO>>;
export type TModalWindow = {
    uid: Array<string>;
    isOpen: boolean;
    options: TCommonBottomSheetOption;
};
export type TBottomSheetsWidgetsMap = Record<string, TModalWindow>;
export type TModalWidgetsMap = Record<string, TModalWindow>;
export type TSystemActin = {
    action: TWAction;
    widget: TWidget<TCommonData>;
};
export type TSystemActions = Record<ActionSystemActionType, TSystemActin>;
export type TMutableWidgetsData = TInputData | TCalculatorData | TButtonData | TCommonData;
export type TMutableWidgetsOption = TCommonOption & TCommonInputOption;
export type TInternalWidgets = Record<string, string>;
export type TInitWidgetState = {
    mutableWidgetsMap: IMutableWidgetsMap<TMutableWidgetsData, TMutableWidgetsOption>;
    bottomSheetMap: TBottomSheetsWidgetsMap;
    modalWindowMap: TModalWidgetsMap;
    systemActions: TSystemActions;
    internalIdWidgets: TInternalWidgets;
    functions?: Record<string, TWidget<TCommonData>['functions']>;
    submitWidget?: TWidget<TButtonData>;
    rootWidgets?: Array<string>;
};

export type TStateScenario = {
    scenarioId: string;
    currentPageId: string;
    playerId?: string;
    themes?: Themes;
    configuration?: TConfiguration;
} & IBaseState &
    TInitWidgetState;

export interface IStateSession extends IBaseState {
    auth?: Record<string, string>;
    environment: IEnvironment;
    parent?: IStateSession;
}

export interface IEnvironment {
    realm: string;
    locale: string;
    data: IEnvironmentData;
    requestUri?: TRequestUri;
}

export interface IEnvironmentData {
    deviceTheme: string;
    userAgent: string;
    operatingSystem: string;
    model?: string;
    id: string;
    deviceId: string;
    authApp: string;
    authSource: string;
    screenHeight: string;
    screenWidth: string;
    browserTimeZone: string;
    browserTimeZoneOffset: string;
    colorDepth: string;
    screenPrint: string;
    externalData?: Record<string, string>;
}

export interface IBody {
    session: IStateSession;
    action?: TWAction;
}

export interface IRootState {
    scenario: TStateScenario;
}

export interface IUpdateWidgetPropertyByPath {
    widget?: TWidget<TCommonData>;
    uid?: string;
    path: string;
    value: TCommonWidgetValue;
}
